import { type ThemeJSON } from "@/lib/theme"

export const techTheme: ThemeJSON = {
  light: {
    "--background": "0 0% 100%",
    "--foreground": "242.1687 47.4286% 34.3137%",
    "--card": "0 0% 100%",
    "--card-foreground": "242.1687 47.4286% 34.3137%",
    "--popover": "0 0% 100%",
    "--popover-foreground": "242.1687 47.4286% 34.3137%",
    "--primary": "258.3117 89.5349% 66.2745%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "252.0000 100% 97.0588%",
    "--secondary-foreground": "244.5205 57.9365% 50.5882%",
    "--muted": "250.0000 100% 97.6471%",
    "--muted-foreground": "262.1229 83.2558% 57.8431%",
    "--accent": "214.2857 94.5946% 92.7451%",
    "--accent-foreground": "225.9310 70.7317% 40.1961%",
    "--destructive": "0 84.2365% 60.1961%",
    "--destructive-foreground": "0 0% 100%",
    "--border": "226.4516 100% 93.9216%",
    "--input": "226.4516 100% 93.9216%",
    "--ring": "258.3117 89.5349% 66.2745%",
    "--chart-1": "258.3117 89.5349% 66.2745%",
    "--chart-2": "262.1229 83.2558% 57.8431%",
    "--chart-3": "263.3898 69.9605% 50.3922%",
    "--chart-4": "263.3557 69.3023% 42.1569%",
    "--chart-5": "263.5000 67.4157% 34.9020%",
    "--sidebar": "250.0000 100% 97.6471%",
    "--sidebar-foreground": "242.1687 47.4286% 34.3137%",
    "--sidebar-primary": "258.3117 89.5349% 66.2745%",
    "--sidebar-primary-foreground": "0 0% 100%",
    "--sidebar-accent": "214.2857 94.5946% 92.7451%",
    "--sidebar-accent-foreground": "225.9310 70.7317% 40.1961%",
    "--sidebar-border": "226.4516 100% 93.9216%",
    "--sidebar-ring": "258.3117 89.5349% 66.2745%",
    "--font-sans": "Roboto, sans-serif",
    "--font-serif": "Playfair Display, serif",
    "--font-mono": "Fira Code, monospace",
    "--radius": "0.625rem",
    "--shadow-x": "2px",
    "--shadow-y": "2px",
    "--shadow-blur": "4px",
    "--shadow-spread": "0px",
    "--shadow-opacity": "0.2",
    "--shadow-color": "255 86% 66%",
    "--shadow-2xs": "2px 2px 4px 0px hsl(255 86% 66% / 0.10)",
    "--shadow-xs": "2px 2px 4px 0px hsl(255 86% 66% / 0.10)",
    "--shadow-sm":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)",
    "--shadow":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-md":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 2px 4px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-lg":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 4px 6px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-xl":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 8px 10px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-2xl": "2px 2px 4px 0px hsl(255 86% 66% / 0.50)",
    "--tracking-normal": "0em",
    "--spacing": "0.25rem"
  },
  dark: {
    "--background": "222.2222 47.3684% 11.1765%",
    "--foreground": "226.4516 100% 93.9216%",
    "--card": "243.7500 47.0588% 20%",
    "--card-foreground": "226.4516 100% 93.9216%",
    "--popover": "243.7500 47.0588% 20%",
    "--popover-foreground": "226.4516 100% 93.9216%",
    "--primary": "258.3117 89.5349% 66.2745%",
    "--primary-foreground": "0 0% 100%",
    "--secondary": "243.7500 47.0588% 20%",
    "--secondary-foreground": "226.4516 100% 93.9216%",
    "--muted": "243.5294 56.0440% 17.8431%",
    "--muted-foreground": "252.5000 94.7368% 85.0980%",
    "--accent": "244.5205 57.9365% 50.5882%",
    "--accent-foreground": "226.4516 100% 93.9216%",
    "--destructive": "0 84.2365% 60.1961%",
    "--destructive-foreground": "0 0% 100%",
    "--border": "261.1765 72.6496% 22.9412%",
    "--input": "261.1765 72.6496% 22.9412%",
    "--ring": "258.3117 89.5349% 66.2745%",
    "--chart-1": "255.1351 91.7355% 76.2745%",
    "--chart-2": "258.3117 89.5349% 66.2745%",
    "--chart-3": "262.1229 83.2558% 57.8431%",
    "--chart-4": "263.3898 69.9605% 50.3922%",
    "--chart-5": "263.3557 69.3023% 42.1569%",
    "--sidebar": "222.2222 47.3684% 11.1765%",
    "--sidebar-foreground": "226.4516 100% 93.9216%",
    "--sidebar-primary": "258.3117 89.5349% 66.2745%",
    "--sidebar-primary-foreground": "0 0% 100%",
    "--sidebar-accent": "244.5205 57.9365% 50.5882%",
    "--sidebar-accent-foreground": "226.4516 100% 93.9216%",
    "--sidebar-border": "261.1765 72.6496% 22.9412%",
    "--sidebar-ring": "258.3117 89.5349% 66.2745%",
    "--font-sans": "Roboto, sans-serif",
    "--font-serif": "Playfair Display, serif",
    "--font-mono": "Fira Code, monospace",
    "--radius": "0.625rem",
    "--shadow-x": "2px",
    "--shadow-y": "2px",
    "--shadow-blur": "4px",
    "--shadow-spread": "0px",
    "--shadow-opacity": "0.2",
    "--shadow-color": "255 86% 66%",
    "--shadow-2xs": "2px 2px 4px 0px hsl(255 86% 66% / 0.10)",
    "--shadow-xs": "2px 2px 4px 0px hsl(255 86% 66% / 0.10)",
    "--shadow-sm":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)",
    "--shadow":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-md":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 2px 4px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-lg":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 4px 6px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-xl":
      "2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 8px 10px -1px hsl(255 86% 66% / 0.20)",
    "--shadow-2xl": "2px 2px 4px 0px hsl(255 86% 66% / 0.50)",
    "--tracking-normal": "0em",
    "--spacing": "0.25rem"
  }
}
